import { type LanguageKey, LanguageIds } from "@packages/core/language/language.ts";
import type { Runtime } from "@squide/firefly";
import { i18nextPlugin, type i18nextPluginOptions } from "@squide/i18next";
import { setApiLanguageResolver } from "./apiLanguage.ts";

export function createI18NextPlugin(runtime: Runtime, options?: i18nextPluginOptions) {
    const plugin = new i18nextPlugin<LanguageKey>(runtime, [...LanguageIds], LanguageIds[0], "language", {
        ...options,
        detection: {
            convertDetectedLanguage: lng => lng.split("-")[0] || lng,
            ...options?.detection
        }
    });

    plugin.detectUserLanguage();

    setApiLanguageResolver(() => plugin.currentLanguage);

    return plugin;
}
